import { AnimatePresence } from 'framer-motion'
import { navigate } from 'gatsby'
import moment from 'moment'
import 'moment/locale/de-ch'
import 'moment/locale/fr-ch'
import 'moment/locale/it-ch'
import React, { useEffect } from 'react'
import { useLocation } from 'react-use'
import { useDataLayer } from '../../hooks/useDataLayer'
import { useLang } from '../../hooks/useLang'
import { useToolOverlay } from '../Context/ToolOverlayContext'
import Footer from '../organisms/Footer'
import Header from '../organisms/Header'
import ToolOverlay from '../organisms/ToolOverlay'
import ToolsButton from '../organisms/ToolsButton'

const Layout = ({
  headerVariant = 'standard',
  alternates,
  invertedHeader,
  children,
}) => {
  const location = useLocation()
  const toolOverlay = useToolOverlay()
  const dataLayer = useDataLayer()
  const { isToolOverlayOpen, setToolOverlayOpen, setContextSectionLimit } =
    toolOverlay
  const lang = useLang()
  moment.locale(`${lang}-ch`)

  useEffect(() => {
    function handleClick(event) {
      if (event.target.id === 'open-planungstool') {
        event.preventDefault()
        setContextSectionLimit('planningtool')
        setToolOverlayOpen(true)
      }
    }

    // Add the event listener to the document
    document.addEventListener('click', handleClick)

    // Clean up the event listener when the component is unmounted
    return () => {
      document.removeEventListener('click', handleClick)
    }
  }, [])

  if (
    location.pathname === '/de' &&
    typeof navigator !== 'undefined' &&
    typeof window !== 'undefined' &&
    !window.localStorage.getItem('langOverride')
  ) {
    const dePos = navigator.languages.indexOf('de-CH')
    const frChPos = navigator.languages.indexOf('fr-CH')
    const frFrPos = navigator.languages.indexOf('fr-IT')
    const frPos = navigator.languages.indexOf('fr')
    const itChPos = navigator.languages.indexOf('it-CH')
    const itItPos = navigator.languages.indexOf('it-IT')
    const itPos = navigator.languages.indexOf('it')

    if (
      (dePos === -1 && frChPos !== -1) ||
      (dePos !== -1 && frChPos !== -1 && frChPos < dePos)
    ) {
      navigate('/fr')
      return null
    }

    if (
      (dePos === -1 && frFrPos !== -1) ||
      (dePos !== -1 && frFrPos !== -1 && frFrPos < dePos)
    ) {
      navigate('/fr')
      return null
    }

    if (
      (dePos === -1 && frPos !== -1) ||
      (dePos !== -1 && frPos !== -1 && frPos < dePos)
    ) {
      navigate('/fr')
      return null
    }

    if (
      (dePos === -1 && itChPos !== -1) ||
      (dePos !== -1 && itChPos !== -1 && itChPos < dePos)
    ) {
      navigate('/it')
      return null
    }

    if (
      (dePos === -1 && itItPos !== -1) ||
      (dePos !== -1 && itItPos !== -1 && itItPos < dePos)
    ) {
      navigate('/it')
      return null
    }

    if (
      (dePos === -1 && itPos !== -1) ||
      (dePos !== -1 && itPos !== -1 && itPos < dePos)
    ) {
      navigate('/it')
      return null
    }
  }

  const handleOpenTool = (label = null, eventLocation = 'header') => {
    setToolOverlayOpen(true)

    dataLayer.push({
      event: 'userinteraction',
      eventCategory: 'Navigation',
      eventAction: 'click',
      eventLabel: label || 'Kontakt',
      event_location: label ? 'header' : eventLocation,
    })
  }

  const normalizedHeaderVariant = headerVariant || 'standard'

  return (
    <div>
      <Header
        inverted={invertedHeader}
        onOpenTool={handleOpenTool}
        alternates={alternates}
        variant={normalizedHeaderVariant}
      />
      {normalizedHeaderVariant === 'standard' && (
        <Header
          overlay
          inverted={invertedHeader}
          onOpenTool={handleOpenTool}
          alternates={alternates}
          variant={normalizedHeaderVariant}
        />
      )}
      {normalizedHeaderVariant !== 'noMenu' && (
        <ToolsButton
          inverted={invertedHeader}
          onOpenTool={handleOpenTool}
          onOpenCollapsedTool={() => handleOpenTool(null, 'sticky')}
        />
      )}
      <AnimatePresence>
        {isToolOverlayOpen && (
          <ToolOverlay onClose={() => setToolOverlayOpen(false)} />
        )}
      </AnimatePresence>
      <main>{children}</main>
      <Footer alternates={alternates} />
    </div>
  )
}

export default Layout
